import { useEffect, useState } from 'react';
import { ViewPresetId } from 'components/organisms/resource-management/scheduler-config/view-presets/constants';
import { ValidViewPresetsForDemand } from 'components/organisms/resource-management/scheduler-config/view-presets/demand-view-presets';
import { useHash } from 'hooks/use-hash';
import { useLocalStorage } from 'hooks/use-local-storage';
import { from_hash, viewPresetTransformer } from '../transformers';

export const useDemandViewPresetState = (): {
  viewPreset: ViewPresetId;
  setViewPreset: (next: ViewPresetId) => void;
  isStateRestored: boolean;
} => {
  const [initialized, setInitialized] = useState(false);

  const [viewPreset, setViewPreset, getNextViewPreset] = useHash(
    viewPresetTransformer(ValidViewPresetsForDemand),
  );
  const [zoomHash, storeZoomHash] = useLocalStorage(
    'resource_management.demand.zoom_level',
    '',
  );

  useEffect(() => {
    if (!initialized) {
      return;
    }

    storeZoomHash(getNextViewPreset(viewPreset));
  }, [getNextViewPreset, initialized, storeZoomHash, viewPreset]);
  useEffect(() => {
    if (initialized) {
      return;
    }
    setViewPreset(from_hash(ValidViewPresetsForDemand)(zoomHash));
    setInitialized(true);
  }, [initialized, setViewPreset, zoomHash]);

  return {
    viewPreset,
    setViewPreset,
    isStateRestored: initialized,
  };
};
